const UploadThumbnailView = require('../thumbnail/upload');
let bucketEndpoint = INKIVE.Helpers.getBucketUrl(INKIVE.C.BUCKET);
bucketEndpoint = bucketEndpoint.substr(0, bucketEndpoint.lastIndexOf('/'));

module.exports = {
  uploadingThumbs: {},
  uploadAttempt: {},
  files: {},
  uploadPath: '/uploads',
  uploadConfig: {
    request: {
      endpoint: bucketEndpoint,
      accessKey: INKIVE.C.UPLOAD_KEY,
      forceMultipart: false
    }
  },

  initialize: function (path) {
    _.bindAll(this,
      'complete',
      'errorEvent',
      'getUploadKey',
      'completeEvent',
      'uploadFileContent'
    );

    this.uploadPath = path || this.uploadPath;

    this.addUploadThumbnail();
    this.initializeUpload();
  },

  addUploadThumbnail: function () {
    this.$el.find('.thumbnail-wrapper:not(.folders)').after($('<ul class="uploader-wrapper hidden"></ul>'));

    const $thumbnailWrapper = this.$el.find('.uploader-wrapper');

    this.$uploaderThumbnail = $('<div></div>').addClass('thumbnail uploader');

    $thumbnailWrapper.append(this.$uploaderThumbnail);
    this.views = {};

    this.views.uploadThumbnail = new UploadThumbnailView({
      el: this.$uploaderThumbnail
    });
  },

  initializeUpload: function () {
    this.$container = this.$el.find('.uploader.progress-button');
    this.$container.fineUploaderS3(this.getUploaderOptions())
      .on('error', this.errorEvent)
      .on('complete', this.completeEvent);
  },

  uploadFileContent: function (content, blobOptions = { type: 'text/plain;charset=utf-8' }) {
    const fileContent = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), content], blobOptions);
    const file = new File([fileContent], (new Date()).valueOf() + '.svg', blobOptions);

    this.$container.fineUploaderS3('addFiles', file);
  },

  getUploaderOptions: function () {
    const globalConfig = INKIVE.C.DEFAULT_FINEUPLOADER;
    const options = $.extend(true, {
      button: this.$el.find('.uploader.progress-button'),
      objectProperties: { acl: 'public-read', key: this.getUploadKey }
    }, globalConfig, this.uploadConfig);

    options.uploadSuccess = {};

    return options;
  },

  getUploadKey: function (id) {
    const regEx = /(?:\.([^.]+))?$/;

    const name = this.$container.fineUploaderS3('getName', id);
    const udid = this.$container.fineUploaderS3('getUuid', id);
    const extension = regEx.exec(name)[1];
    const bucketUrl = INKIVE.Helpers.getBucketUrl(INKIVE.C.BUCKET).split('/').pop().split('.')[0];

    return bucketUrl + this.uploadPath + '/' + udid + '.' + extension;
  },

  errorEvent: function (event, id) {
    const view = this.views[id];

    INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
      message: 'modal.alert.upload_image',
      try_again: true
    }));

    this.clean(id);
    _.delay(function () { view && view.remove(); }, 1000);
    $(document).trigger('file-content-upload:error');
    return true;
  },

  completeEvent: function (event, id, fileName, response, xhr) {
    const $container = $(event.currentTarget);

    if (response.success) {
      this.complete(id, fileName, response);
    } else {
      this.errorEvent(event, id) && $container.fineUploaderS3('cancel', id);
    }
  },

  complete: function (id, fileName, response) {
    const key = this.getUploadKey(id);
    this.clean(id);
    $(document).trigger('file-content-upload:complete', [bucketEndpoint + '/' + key, fileName]);
  },

  clean: function (id) {
    this.files = _.omit(this.files, id);
    this.uploadAttempt = _.omit(this.uploadAttempt, id);
  },

  // TODO: use & test upload fallback for weak connections
  forceFallbackUpload: function () {
    INKIVE.C.USE_FALLBACK_UPLOAD = 'FORCE';
  },

  isFallbackUploadForced: function () {
    return INKIVE.C.USE_FALLBACK_UPLOAD === 'FORCE';
  }
};
